import * as React from 'react';
import styled from 'styled-components';

import { Spinner } from '@/components/Elements';

const SpinnerContainerWrap = styled.div`
  .spinner__container {
    min-height: calc(100vh - 186px);
  }
`;

export type SpinnerContainerProps = {
  className?: string;
};

export const SpinnerContainer = ({ className }: SpinnerContainerProps) => {
  return (
    <SpinnerContainerWrap>
      <div className={`spinner__container flex items-center justify-center w-full ${className}`}>
        <Spinner className="relative" size="xl" />
      </div>
    </SpinnerContainerWrap>
  );
};
